export const baseURL = "http://localhost/doss_gold_loan/api/";
// export const baseURL = "https://40ff-2406-7400-bb-529-d5bb-4674-6db3-f480.ngrok-free.app/doss_gold_loan/api/";
// export const baseURL = "https://smrgoldloanfinance.com/api/"
// export const baseURL = "http://192.168.0.103/doss_gold_loan/api/";

const API = async (requestURL, requestAPIData) => {
  const APIENDPOINT = baseURL + requestURL.url;

  const headersData = {};

  if (requestURL.authorization) {
    const token = localStorage.getItem("token") || "";
    headersData["Authorization"] = "Bearer " + token;
  }

  const requestAPIHeader = {
    method: requestURL.method,
    headers: headersData,
  };

  if (requestURL.method !== "GET" && requestURL.method !== "DELETE") {
    if (requestAPIData.bodyData instanceof FormData) {
      requestAPIHeader.body = requestAPIData.bodyData;
    } else {
      headersData["Content-Type"] = "application/json";
      requestAPIHeader.body = JSON.stringify(requestAPIData.bodyData);
    }
  }

  try {
    const response = await fetch(APIENDPOINT, requestAPIHeader);
    const contentType = response.headers.get("Content-Type");

    if (
      contentType &&
      contentType.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
    ) {
      return await response.blob();
    } else {
      return await response.json();
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export default API;
